export const DEFAULT_COLUMN_VISIBILITY = true
export const DEFAULT_COLUMN_ALLOW_REORDERING = true
